module.exports = __webpack_public_path__ + "static/img/banner_4.6dd99bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_4.jpg
// module id = geVL
// module chunks = 0